import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import $ from 'jquery';
var MenuToggle = /*#__PURE__*/function () {
  function MenuToggle() {
    var _this = this;
    _classCallCheck(this, MenuToggle);
    /* 
     * Event Handlers
     */
    _defineProperty(this, "onClick", function (e) {
      if (e.target !== e.currentTarget) {
        // Do nothing if click event bubbled up to bound element
        return;
      }
      _this.toggle();
    });
    this.selector = '.menu-toggle';
    this.$el = $(this.selector);
    this.$toggle = this.$el.find("".concat(this.selector, "__button"));
    this.$target = $(this.$toggle.attr('data-target'));
    this.$body = $(document.body);
    if (!this.$toggle || !this.$target) return false;
    this.bindEvents();
  }
  _createClass(MenuToggle, [{
    key: "bindEvents",
    value: function bindEvents() {
      this.$toggle.on('click', this.onClick);
      var that = this;
      $(".menu-item a").on("click", function () {
        that.$toggle.attr('data-expanded', 'false').attr('data-aria-expanded', 'false').trigger('blur');
        that.$body.removeClass('mobile-menu-is-open');
      });
    }
  }, {
    key: "toggle",
    value:
    /*
     * API
     */

    function toggle(state) {
      if (state == undefined) {
        var currentState = this.$toggle.attr('data-expanded') == 'true';
        state = !currentState;
      }
      this.$toggle.attr('data-expanded', state).attr('data-aria-expanded', state).trigger('blur');
      this.$body.toggleClass('mobile-menu-is-open', state);
    }
  }]);
  return MenuToggle;
}();
$(function () {
  new MenuToggle();
});